import React from "react";
import styled from "styled-components";
import { useFilterContext } from "../context/filter_context";
import { formatPrice } from "../utils/helpers";
import { FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";

const itemsCategories = [
  "party stany",
  "party nábytek",
  "party vybavení",
  "cateringové vybavení",
  "ostatní",
];

const Filters = () => {
  const {
    filters: { text, category, min_price, price, max_price },
    updateFilters,
    clearFilters,
  } = useFilterContext();

  return (
    <Wrapper>
      <details className="filters-accordion" open>
        <summary>Filtry</summary>
        <div className="content">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="form-control">
              <div className="search-wrap">
                <FaSearch className="search-icon" />
                <input
                  type="text"
                  name="text"
                  placeholder="Vyhledat produkt"
                  className="search-input"
                  value={text}
                  onChange={updateFilters}
                />
              </div>
            </div>

            <div className="form-control">
              <h5>Kategorie</h5>
              <div className="chips">
                {itemsCategories.map((product, index) => (
                  <button
                    key={index}
                    onClick={updateFilters}
                    name="category"
                    type="button"
                    className={`chip ${category === product ? "active" : ""}`}
                  >
                    {product}
                  </button>
                ))}
              </div>
            </div>

            <div className="form-control">
              <h5>Cena</h5>
              <p className="price">{formatPrice(price)}</p>
              <input
                type="range"
                name="price"
                onChange={updateFilters}
                min={min_price}
                max={max_price}
                value={price}
                className="price-slider"
              />
            </div>
          </form>

          <Link to="/extra" className="extra-link">
            Doplňkový prodej
          </Link>
          <button type="button" className="clear-btn" onClick={clearFilters}>
            Vyčistit filtry
          </button>
        </div>
      </details>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .filters-accordion {
    background: var(--clr-paper);
    border: 1px solid var(--clr-divider);
    border-radius: var(--radius-lg);
    padding: 1rem 1.25rem;
    box-shadow: var(--shadow-sm);
  }
  summary {
    cursor: pointer;
    font-family: var(--ff-display);
    font-size: 1.15rem;
    font-weight: 600;
    color: var(--clr-charcoal-1);
    list-style: none;
    padding: 0.25rem 0;
    user-select: none;
  }
  summary::-webkit-details-marker {
    display: none;
  }
  summary::after {
    content: "▾";
    float: right;
    color: var(--clr-accent-dark);
    transition: transform var(--transition);
  }
  .filters-accordion[open] summary::after {
    transform: rotate(180deg);
    display: inline-block;
  }

  .content {
    padding-top: 1rem;
  }

  .form-control {
    margin-bottom: 1.5rem;
  }
  .form-control h5 {
    margin-bottom: 0.6rem;
    font-family: var(--ff-body);
    color: var(--clr-charcoal-1);
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
  }

  .search-wrap {
    position: relative;
  }
  .search-icon {
    position: absolute;
    left: 0.85rem;
    top: 50%;
    transform: translateY(-50%);
    color: var(--clr-charcoal-3);
    font-size: 0.9rem;
  }
  .search-input {
    width: 100%;
    padding: 0.7rem 0.75rem 0.7rem 2.4rem;
    background: var(--clr-cream-warm);
    border: 1px solid var(--clr-divider);
    border-radius: var(--radius-pill);
    color: var(--clr-charcoal-1);
    font-family: var(--ff-body);
    font-size: 0.95rem;
    transition: var(--transition);
  }
  .search-input:focus {
    outline: none;
    background: var(--clr-paper);
    border-color: var(--clr-accent);
    box-shadow: 0 0 0 3px rgba(184, 115, 51, 0.15);
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
  }
  .chip {
    display: inline-block;
    background: transparent;
    border: 1px solid var(--clr-divider);
    color: var(--clr-charcoal-2);
    padding: 0.4rem 0.85rem;
    border-radius: var(--radius-pill);
    font-family: var(--ff-body);
    font-size: 0.85rem;
    cursor: pointer;
    transition: var(--transition);
    text-transform: capitalize;
    letter-spacing: 0;
  }
  .chip:hover {
    border-color: var(--clr-accent);
    color: var(--clr-accent-dark);
  }
  .chip.active {
    background: var(--clr-accent);
    color: var(--clr-paper);
    border-color: var(--clr-accent);
  }

  .price {
    margin-bottom: 0.5rem;
    color: var(--clr-accent-dark);
    font-weight: 600;
  }
  .price-slider {
    width: 100%;
    accent-color: var(--clr-accent);
  }
  .price-slider::-webkit-slider-thumb {
    background: var(--clr-accent);
  }

  .extra-link {
    display: inline-block;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    color: var(--clr-accent-dark);
    font-weight: 600;
    padding: 0.5rem 1rem;
    border: 1px solid var(--clr-accent);
    border-radius: var(--radius-pill);
    transition: var(--transition);
  }
  .extra-link:hover {
    background: var(--clr-accent);
    color: var(--clr-paper);
  }

  .clear-btn {
    background: transparent;
    color: var(--clr-red-dark);
    border: 1px solid var(--clr-red-dark);
    padding: 0.5rem 1rem;
    border-radius: var(--radius-pill);
    cursor: pointer;
    font-family: var(--ff-body);
    font-size: 0.85rem;
    transition: var(--transition);
    margin-top: 0.5rem;
  }
  .clear-btn:hover {
    background: var(--clr-red-dark);
    color: var(--clr-paper);
  }

  @media (min-width: 768px) {
    position: sticky;
    top: 6rem;
  }
`;

export default Filters;
